import { Endpoints } from '../../constants/endpoints'
import { getApiDataFile } from '../_GLOBAL/getApiData'

export const getDataExcelRequests = (datumOd: string, datumDo: string) =>
  getApiDataFile(Endpoints.dataExcelRequests(datumOd, datumDo))

export const getDataNewsFileRequests = (id: number, name: string) =>
  getApiDataFile(Endpoints.dataNewsFileRequest(id, name))
